import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Form,
  Grid,
  Icon,
  Input,
  TextArea,
  Modal,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";

import {
  editAdvocate,
  deleteFieldFromAdvocate,
} from "../../store/actions/athleteActions";
import { BsFillPatchCheckFill } from "react-icons/bs";
import {
  fbregex,
  igregex,
  imageRegex,
  linkedinRegex,
  phoneRegex,
  twitterRegex,
} from "../../utils/regex";
const EditAdvocate = (props) => {
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailUrl, setThumbnailUrl] = useState(null);
  const [error, setError] = useState(false);
  const [warning, setWarning] = useState(false);
  const [name, setName] = useState(null);
  const [title, setTitle] = useState(null);
  const [facebook, setFacebook] = useState(null);
  const [instagram, setInstagram] = useState(null);
  const [twitter, setTwitter] = useState(null);
  const [linkedin, setLinkedin] = useState(null);
  const [phone, setPhone] = useState(null);
  const [email, setEmail] = useState(null);
  const [info, setInfo] = useState(null);
  const dispatch = useDispatch();
  const emailRegex =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const data = props.editData;
  const submitData = {};
  const handleSubmit = () => {
    submitData.id = data.id;
    submitData.email = data.email;
    submitData.order = data.order;
    submitData.name = name ? name : data.name;
    submitData.title = title ? title : data.title;
    submitData.about = info ? info : data.about;

    if (thumbnail) {
      submitData.thumbnail = thumbnail;
    }
    if (facebook) {
      submitData.facebook = facebook;
    }
    if (twitter) {
      submitData.twitter = twitter;
    }
    if (instagram) {
      submitData.instagram = instagram;
    }
    if (linkedin) {
      submitData.linkedin = linkedin;
    }
    if (phone) {
      submitData.phone = phone;
    }
    if (email) {
      submitData.email = email;
    }
    if (!error) {
      dispatch(editAdvocate(submitData));
      !thumbnail && handleClose();
      setThumbnail(false);
      setThumbnailUrl(false);
      setError(false);
      setWarning(false);
      setName(false);
      setTitle(false);
      setFacebook(false);
      setInstagram(false);
      setTwitter(false);
      setLinkedin(false);
      setPhone(false);
      setEmail(false);
      setInfo(false);
    }
  };

  const handleThumbnail = (e) => {
    if (imageRegex.test(e.target.files[0].name)) {
      setThumbnailUrl(URL.createObjectURL(e.target.files[0]));
      setThumbnail(e.target.files[0]);
    } else {
      setError("It should be image");
    }
  };

  const handleTitleChange = (data) => {
    setTitle(data);
  };
  const handleNameChange = (data) => {
    setName(data);
  };
  const handleInfoChange = (data) => {
    setInfo(data);
  };
  const handleFacebookChange = (data) => {
    if (fbregex.test(data)) {
      setFacebook(data);
      setWarning(false);
    } else {
      setWarning("It Should Be Facebook Profile");
    }
  };
  const handleInstagramChange = (data) => {
    if (igregex.test(data)) {
      setInstagram(data);
      setWarning(false);
    } else {
      setWarning("It Should Be Instagram Profile");
    }
  };
  const handleTwitterChange = (data) => {
    if (twitterRegex.test(data)) {
      setTwitter(data);
      setWarning(false);
    } else {
      setWarning("It Should Be Twitter Profile");
    }
  };
  const handleLinkedinChange = (data) => {
    if (linkedinRegex.test(data)) {
      setLinkedin(data);
      setWarning(false);
    } else {
      setWarning("It Should Be Linkedin Profile");
    }
  };
  const handlePhoneChange = (data) => {
    if (phoneRegex.test(data)) {
      setPhone(data);
      setWarning(false);
    } else {
      setWarning("It Should Be Cell Number Without any characters");
    }
  };
  const handleDeleteField = (id, field) => {
    setWarning("Field Deleted Succesfully It'll Reflect Once You Save");
    dispatch(deleteFieldFromAdvocate(id, field));
  };
  const handleClose = () => {
    props.onClose();
    setThumbnail(false);
    setError(false);
    setWarning(false);
    setName(false);
    setTitle(false);
    setFacebook(false);
    setInstagram(false);
    setTwitter(false);
    setLinkedin(false);
    setPhone(false);
    setEmail(false);
    setInfo(false);
  };
  props.progress === 100 &&
    setTimeout(() => {
      handleClose();
    }, 2000);
  if (props.editData) {
    return (
      <Modal onClose={props.onClose} open={props.open}>
        <Modal.Content scrolling>
          <div className="AdminTopButtonsProgressContainer">
            <div className="AdminTopButtonsContainer d-custom">
              <Button
                floated="left"
                circular
                icon="close"
                onClick={handleClose}
              />
              <div className="d-CustomInnderdiv">
                {props.progress === 100 && (
                  <span className="successPlayerToWatch">
                    Added <BsFillPatchCheckFill size={16} />
                  </span>
                )}
                {!error && !props.saving && (
                  <Button
                    floated="right"
                    positive
                    name="saveButton"
                    content="Save"
                    labelPosition="right"
                    icon="checkmark"
                    onClick={handleSubmit}
                  />
                )}
                {error && (
                  <Button
                    floated="right"
                    disabled
                    name="saveButton"
                    content="Save"
                    labelPosition="right"
                    icon="checkmark"
                    onClick={handleSubmit}
                  />
                )}
                {props.saving && (
                  <Button
                    floated="right"
                    loading
                    name="saveButton"
                    content="Save"
                    labelPosition="right"
                    icon="checkmark"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="head-data">
            <h3 className="cu-center">Edit {data.name}</h3>
            {error && <p style={{ color: "#800000" }}>{error}</p>}
            {warning && <p style={{ color: "#FF6600" }}>{warning}</p>}
          </div>
          <ul className="full mix-both">
            <li>
              <div className="full-skills full">
                <div className="one-skill">
                  <div className="thumbnail-advocate-image">
                    {data.thumbnailUrl && !thumbnailUrl && (
                      <img src={data.thumbnailUrl} alt={"thumbnail"} />
                    )}
                    {thumbnailUrl && (
                      <img src={thumbnailUrl} alt={"thumbnail"} />
                    )}
                    <label htmlFor="thumbnail">
                      <Icon name="upload" />
                    </label>
                    <Input
                      type="file"
                      className="upload-img-btn"
                      id="thumbnail"
                      style={{ display: "none" }}
                      placeholder="Select image"
                      onChange={handleThumbnail}
                    />
                  </div>
                </div>
                <div className="two-skill">
                  <Grid divided="vertically">
                    <Grid.Row stackable="true" columns={2}>
                      <Grid.Column mobile={16} tablet={16} computer={8}>
                        <Form.Field>
                          <label>Name *</label>
                          <Input
                            defaultValue={data.name}
                            onChange={(e) => handleNameChange(e.target.value)}
                          />
                        </Form.Field>
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={8}>
                        <Form.Field>
                          <label>Title *</label>
                          <Input
                            defaultValue={data.title}
                            onChange={(e) => handleTitleChange(e.target.value)}
                          />
                        </Form.Field>
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={16}>
                        <Form.Field>
                          <label>About Us *</label>
                          <TextArea
                            rows={5}
                            defaultValue={data.about}
                            className="cu-textarea"
                            onChange={(e) => handleInfoChange(e.target.value)}
                          />
                        </Form.Field>
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={8}>
                        <Form.Field>
                          <label>Email *</label>
                          <Input
                            disabled
                            defaultValue={`${data.email} <- You Can't Edit This`}
                          />
                        </Form.Field>
                      </Grid.Column>
                      {
                        <Grid.Column mobile={16} tablet={16} computer={8}>
                          <Form.Field>
                            <label>Facebook</label>
                            <div className="inline-input-group">
                              {data.facebook ? (
                                <Input
                                  defaultValue={data.facebook}
                                  onChange={(e) =>
                                    handleFacebookChange(e.target.value)
                                  }
                                />
                              ) : (
                                <Input
                                  placeholder="Facebook URL"
                                  onChange={(e) =>
                                    handleFacebookChange(e.target.value)
                                  }
                                />
                              )}
                              <Button
                                color="red"
                                name="RemovePlayerButton"
                                onClick={() =>
                                  handleDeleteField(data.id, "facebook")
                                }
                              >
                                <Icon name="minus" />
                              </Button>
                            </div>
                          </Form.Field>
                        </Grid.Column>
                      }
                      <Grid.Column mobile={16} tablet={16} computer={8}>
                        <Form.Field>
                          <label>Twitter</label>
                          <div className="inline-input-group">
                            {data.twitter ? (
                              <Input
                                defaultValue={data.twitter}
                                onChange={(e) =>
                                  handleTwitterChange(e.target.value)
                                }
                              />
                            ) : (
                              <Input
                                placeholder="Twitter URL"
                                onChange={(e) =>
                                  handleTwitterChange(e.target.value)
                                }
                              />
                            )}
                            <Button
                              color="red"
                              name="RemovePlayerButton"
                              onClick={() =>
                                handleDeleteField(data.id, "twitter")
                              }
                            >
                              <Icon name="minus" />
                            </Button>
                          </div>
                        </Form.Field>
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={8}>
                        <Form.Field>
                          <label>Instagram</label>
                          <div className="inline-input-group">
                            {data.instagram ? (
                              <Input
                                defaultValue={data.instagram}
                                onChange={(e) =>
                                  handleInstagramChange(e.target.value)
                                }
                              />
                            ) : (
                              <Input
                                placeholder="Instagram URL"
                                onChange={(e) =>
                                  handleInstagramChange(e.target.value)
                                }
                              />
                            )}
                            <Button
                              color="red"
                              name="RemovePlayerButton"
                              onClick={() =>
                                handleDeleteField(data.id, "instagram")
                              }
                            >
                              <Icon name="minus" />
                            </Button>
                          </div>
                        </Form.Field>
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={8}>
                        <Form.Field>
                          <label>Linkedin</label>
                          <div className="inline-input-group">
                            {data.linkedin ? (
                              <Input
                                defaultValue={data.linkedin}
                                onChange={(e) =>
                                  handleLinkedinChange(e.target.value)
                                }
                              />
                            ) : (
                              <Input
                                placeholder="Linkedin URL"
                                onChange={(e) =>
                                  handleLinkedinChange(e.target.value)
                                }
                              />
                            )}
                            <Button
                              color="red"
                              name="RemovePlayerButton"
                              onClick={() =>
                                handleDeleteField(data.id, "linkedin")
                              }
                            >
                              <Icon name="minus" />
                            </Button>
                          </div>
                        </Form.Field>
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={8}>
                        <Form.Field>
                          <label>Cell</label>

                          <div className="inline-input-group">
                            {data.phone ? (
                              <Input
                                defaultValue={data.phone}
                                onChange={(e) =>
                                  handlePhoneChange(e.target.value)
                                }
                              />
                            ) : (
                              <Input
                                placeholder="Cell Number"
                                onChange={(e) =>
                                  handlePhoneChange(e.target.value)
                                }
                              />
                            )}
                            <Button
                              color="red"
                              name="RemovePlayerButton"
                              onClick={() =>
                                handleDeleteField(data.id, "phone")
                              }
                            >
                              <Icon name="minus" />
                            </Button>
                          </div>
                        </Form.Field>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </div>
              </div>
            </li>
          </ul>
        </Modal.Content>
      </Modal>
    );
  } else {
    return null;
  }
};

const mapStateToProps = (state) => {
  return {
    saving: state.athlete.advocateUpdating,
    progress: state.athlete.advocateUpdateProgress,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "advocates",
    },
  ])
)(EditAdvocate);
